import React from "react";
import { Link } from "react-router-dom";
import { MarketingNav } from "@/components/marketing/MarketingNav";
import { MarketingFooter } from "@/components/marketing/MarketingFooter";

export function DataDeletionPage() {
  const lastUpdated = "February 14, 2026";

  return (
    <div className="cb-root">
      <MarketingNav />

      <section className="mx-auto w-full max-w-3xl px-5 pt-24 pb-20 sm:px-8 sm:pt-32">
        <div className="mb-10">
          <p data-testid="cb-dd-updated" className="text-xs font-semibold uppercase tracking-[0.22em] text-[#c8ff00]">
            Last updated: {lastUpdated}
          </p>
          <h1
            data-testid="cb-dd-heading"
            className="cb-display mt-3 text-4xl leading-[1.05] text-white sm:text-5xl"
          >
            Data Deletion
          </h1>
          <p className="mt-4 text-base leading-relaxed text-[#8a8a90]">
            You can permanently delete your ClippingBase account and all associated
            personal data at any time. This page explains how.
          </p>
        </div>

        <div className="cb-legal-body space-y-8 text-[15px] leading-relaxed text-[#c8c8cc]">
          <section>
            <h2 className="mb-3 text-xl font-bold text-white">Delete via the app (fastest)</h2>
            <ol className="ml-5 list-decimal space-y-1.5">
              <li>Sign in to <a href="https://clippingbase.com/login" className="text-[#c8ff00] underline">clippingbase.com</a>.</li>
              <li>Go to <Link to="/settings" className="text-[#c8ff00] underline">Settings</Link>.</li>
              <li>Scroll to <span className="font-semibold text-white">&quot;Delete account&quot;</span> and confirm.</li>
              <li>We remove your personal data (email, hashed password, connected socials, notification history) within 30 days. Anonymised campaign metrics may be retained for accounting and fraud-prevention obligations.</li>
            </ol>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-bold text-white">Delete by email</h2>
            <p>Email <a href="mailto:privacy@clippingbase.com" className="text-[#c8ff00] underline">privacy@clippingbase.com</a> from the address on your account with subject line <span className="font-mono text-white">&quot;Delete my ClippingBase account&quot;</span>. We will confirm receipt within 3 business days and complete deletion within 30 days.</p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-bold text-white">Revoke Instagram / TikTok / YouTube access</h2>
            <p>Deleting your ClippingBase account also revokes the OAuth tokens we hold for your connected social accounts. You can additionally revoke access directly on each platform:</p>
            <ul className="ml-5 list-disc space-y-1.5">
              <li>Instagram → Settings → Website Permissions → Apps and Websites → find &quot;ClippingBase&quot; → Remove.</li>
              <li>YouTube (Google) → myaccount.google.com/permissions → find &quot;ClippingBase&quot; → Remove access.</li>
              <li>TikTok → Settings → Security &amp; Login → Manage app permissions → Revoke.</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-bold text-white">Questions</h2>
            <p>See our <Link to="/privacy" className="text-[#c8ff00] underline">Privacy Policy</Link> or write to <a href="mailto:privacy@clippingbase.com" className="text-[#c8ff00] underline">privacy@clippingbase.com</a>.</p>
          </section>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
